<div class="content">
  <img class="sidebar-logo" src="assets/images/evicon.png" />
  <!-- <div class="sidebar-title">EUROVOLC</div> -->

  <div class="ev-options-buttons">
    <button id="menu-btn" (click)="setActive(SIDEBAR_MODES.CONTRIBUTE)" type="button" [value]="SIDEBAR_MODES.CONTRIBUTE"
      data-toggle="button" class="btn" [class.active]="activeOption === SIDEBAR_MODES.CONTRIBUTE">
      <i class="material-icons md-30">post_add</i>
      <span class="option-text">Contribute</span>
    </button>

    <button id="menu-btn" (click)="setActive(SIDEBAR_MODES.LAYERS)" type="button" [value]="SIDEBAR_MODES.LAYERS"
      data-toggle="button" class="btn" [class.active]="activeOption === SIDEBAR_MODES.LAYERS">
      <i class="material-icons md-30">layers</i>
      <span class="option-text">Layers</span>
    </button>

    <!-- <button id="menu-btn" (click)="setActive(SIDEBAR_MODES.SEARCH)" type="button" [value]="SIDEBAR_MODES.SEARCH"
      data-toggle="button" class="btn" [class.active]="activeOption === SIDEBAR_MODES.SEARCH">
      <i class="material-icons md-30">search</i>
      <span class="option-text">Search</span>
    </button> -->

    <button id="menu-btn" (click)="setActive(SIDEBAR_MODES.FILTER)" type="button" [value]="SIDEBAR_MODES.FILTER"
      data-toggle="button" class="btn" [class.active]="activeOption === SIDEBAR_MODES.FILTER">
      <i class="material-icons md-30">filter_list</i>
      <span class="option-text">Filter</span>
    </button>

    <button id="menu-btn" (click)="setActive(SIDEBAR_MODES.EXPORT)" type="button" [value]="SIDEBAR_MODES.EXPORT"
      data-toggle="button" class="btn" [class.active]="activeOption === SIDEBAR_MODES.EXPORT">
      <i class="material-icons md-30">archive</i>
      <span class="option-text">Export</span>
    </button>

    <!-- <button id="menu-btn" (click)="setActive(SIDEBAR_MODES.BASKET)" type="button" [value]="SIDEBAR_MODES.BASKET"
      data-toggle="button" class="btn" [class.active]="activeOption === SIDEBAR_MODES.BASKET">
      <i class="material-icons md-30">shopping_basket</i>
      <span class="option-text">Basket</span>
    </button> -->

    <button id="menu-btn" (click)="setActive(SIDEBAR_MODES.HELP); helpDialog()" type="button"
      [value]="SIDEBAR_MODES.HELP" data-toggle="button" class="btn"
      [class.active]="activeOption === SIDEBAR_MODES.HELP">
      <i class="material-icons md-30">help_outline</i>
      <span class="option-text">About</span>
    </button>

    <button id="menu-btn" (click)="setActive(SIDEBAR_MODES.CONTACT); contactDialog()" type="button"
      [value]="SIDEBAR_MODES.CONTACT" data-toggle="button" class="btn"
      [class.active]="activeOption === SIDEBAR_MODES.CONTACT">
      <i class="material-icons md-30">mail_outline</i>
      <span class="option-text">Contact</span>
    </button>
  </div>

</div>